import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import BackNavigation from "./common/BackNavigation";

import { UserCreators } from "redux/modules/user";

import { Divider } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import arrow from "../../../assets/icons/arrow-right.svg";

const Agreement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = [
    { id: 0, type: "tos", title: "(필수) 서비스 이용약관" },
    { id: 1, type: "pp1", title: "(필수) 개인정보 수집 및 이용동의" },
    { id: 2, type: "pp2", title: "(선택) 개인정보 수집 및 이용동의" },
    { id: 3, type: "marketing", title: "(선택) 마케팅 알림 수신 동의" },
  ];
  // 체크된 아이템을 담을 배열
  const [checkItems, setCheckItems] = useState([]);

  // 체크박스 단일 선택
  const handleSingleCheck = (checked, id) => {
    if (checked) {
      // 단일 선택 시 체크된 아이템을 배열에 추가
      setCheckItems((prev) => [...prev, id]);
    } else {
      // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
      setCheckItems(checkItems.filter((el) => el !== id));
    }
  };

  // 체크박스 전체 선택
  const handleAllCheck = (checked) => {
    if (checked) {
      // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
      const idArray = [];
      data.forEach((el) => idArray.push(el.id));
      setCheckItems(idArray);
    } else {
      // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
      setCheckItems([]);
    }
  };

  const continueBtnHandler = () => {
    navigate("/signup");
  };

  return (
    <LoginWrapper>
      <AgreeContainer>
        <BackNavigation />
        <Title>
          플로웨이 서비스를 이용하려면
          <br />
          약관 동의가 필요해요
        </Title>
        <AgreeAll>
          <Checkbox
            name="select-all"
            sx={{
              color: "lightgray",
              "&.Mui-checked": {
                color: "#FF7A00",
              },
            }}
            onChange={(e) => handleAllCheck(e.target.checked)}
            // 데이터 개수와 체크된 아이템의 개수가 다를 경우 선택 해제 (하나라도 해제 시 선택 해제)
            checked={checkItems.length === data.length ? true : false}
          />
          <div>전체 동의하기</div>
        </AgreeAll>
        <Divider />
        <AgreeEachContainer>
          {data?.map((data, key) => (
            <AgreeEach key={key}>
              <Checkbox
                name={`select-${data.id}`}
                size="small"
                sx={{
                  color: "lightgray",
                  "&.Mui-checked": {
                    color: "#FF7A00",
                  },
                }}
                onChange={(e) => handleSingleCheck(e.target.checked, data.id)}
                checked={checkItems.includes(data.id) ? true : false}
              />
              <EachContent>
                <div>{data.title}</div>
                <Arrow
                  src={arrow}
                  onClick={() => navigate(`/signup/agreement/${data.type}`)}
                />
              </EachContent>
            </AgreeEach>
          ))}
        </AgreeEachContainer>
      </AgreeContainer>
      <ContinueBtn
        onClick={continueBtnHandler}
        disabled={checkItems.includes(0) && checkItems.includes(1) === false}
      >
        동의하고 계속하기
      </ContinueBtn>
    </LoginWrapper>
  );
};

const LoginWrapper = styled.div`
  width: 100%;
  height: calc(100% - 25px);
  margin: auto;
  position: relative;
`;

const AgreeContainer = styled.div`
  width: 90%;
  height: 65vh;
  margin: 3vh auto;
`;

const AgreeAll = styled.div`
  display: flex;
  height: 5vh;
  line-height: 5vh;
  margin-bottom: 1vh;
`;

const AgreeEachContainer = styled.div`
  height: 15vh;
  margin-top: 2vh;
`;

const AgreeEach = styled.div`
  margin-top: 0.8vh;
  display: flex;
  height: 4.5vh;
  line-height: 4.5vh;
  font-size: 11.5px;
`;

const EachContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const Title = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  margin: 7vh 0vh;
`;

const Arrow = styled.img`
  width: 1.5rem;
`;

const ContinueBtn = styled.button`
  background-color: #ff7a00;
  height: 50px;
  width: 100%;
  border: 0;
  outline: 0;
  color: white;
  position: absolute;
  bottom: 0px;
  &:disabled {
    background-color: lightgray;
    color: gray;
  }
`;

export default Agreement;
